import { useState, useEffect } from 'react';
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import AdultsOnly from "../Login/AdultsOnly";
import OrderTest from "../Login/OrderTest";
import FilterUsers from "../Login/FilterUsers";
import { getLabConfig, getTestInfo } from '../../utils/api';
import { cartActions } from '../../store/cart';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TestInfoClasses from '../Tests/TestInfo.module.css';

const modalStyles = {
  default: {
    width: '50%',
    height: '50%',
    margin: 'auto',
    textAlign: 'center',
  },
  adults: {
    maxWidth: '400px',
    maxHeight: '400px',
  },
  filter: {
    maxWidth: '600px',
    maxHeight: '300px',
  }
};

const ModalStepper = ({
  step,
  setStep,
  filters,
  cartClasses,
  navigate,
  message
}) => {
	const notifyCart = () => toast("Added To Cart");
	const cartState = useSelector(state => state.cart);
    const dispatch = useDispatch();
	const [requiredTests,setRequiredTests] = useState([]);
	useEffect(() => {
			async function fetchRequiredTests() {
				let reqTests='';
					reqTests = await getLabConfig("DTCCONDITIONALTEST");
									console.log(3);
				if (typeof reqTests === 'string' && reqTests.trim() !== '') {
					const testArray=reqTests.split(",");
					const reqTestInfo = [];
					for (let i=0; i< testArray.length; i++) {
						reqTestInfo[i] = await getTestInfo(testArray[i]);
					};
					setRequiredTests(reqTestInfo);    
				}

		}
		fetchRequiredTests();
		}, []);
  const addTest = () => {
	  		if (requiredTests.length !== 0 ) {
			for (let i=0; i<requiredTests.length; i++) {
				const testInfoR=Object.assign({required:0},requiredTests[i]);
				const testInfoRA=Object.assign({aaoeanswers: {"none":"none"}},testInfoR);
				dispatch(cartActions.add(testInfoRA));
			}
		}
        notifyCart();
  }
  if (step === 0) return null;

  const close = () => setStep(0);

  switch (step) {
    case 1:
      return (
        <Modal isOpen={true} onRequestClose={close} shouldCloseOnOverlayClick={false}
          contentLabel="Adults Only"
          style={{ content: { ...modalStyles.default, ...modalStyles.adults } }}
        >
          <AdultsOnly />
          <div className={cartClasses.buttonAreaYesNo}>
            <button className={cartClasses.buttonDarkBlue} onClick={() => {
              sessionStorage.setItem("Adult", "Yes");
              setStep(2);
            }}>Yes</button>
            &nbsp;&nbsp;&nbsp;
            <button className={cartClasses.buttonDarkBlue} onClick={() => {
              sessionStorage.setItem("Adult", "No");
              navigate("/Minor");
            }}>No</button>
          </div>
        </Modal>
      );

    case 2:
	  if (filters[1] == null ) {
		close(); 
		return null;
	  }
      return (
        <Modal isOpen={true} onRequestClose={close} shouldCloseOnOverlayClick={false}
          contentLabel="Filter Users"
          style={{ content: { ...modalStyles.default, ...modalStyles.filter } }}
        >
          <FilterUsers handleUpdate={() => setStep(3)} tableForm={filters} />
        </Modal>
      );

    case 3:
	 if (filters[2] == null || sessionStorage.getItem("Q3") === "Yes" || sessionStorage.getItem("Q3") === "No") {
		close(); 
		return null;
	  }
      return (
        <Modal isOpen={true} onRequestClose={close} shouldCloseOnOverlayClick={false}
          contentLabel="Order Test"
          style={{ content: { ...modalStyles.default, ...modalStyles.adults } }}
        >
          <OrderTest handleUpdate={close} tableForm={filters} />
          <div className={cartClasses.buttonAreaYesNo}>
            <button className={cartClasses.buttonDarkBlue} onClick={() => {
				sessionStorage.setItem("Q3", "Yes");
				close();
			}}>Yes</button>
            &nbsp;&nbsp;&nbsp;
            <button className={cartClasses.buttonDarkBlue} onClick={() =>{
				sessionStorage.setItem("Q3", "No");
				close();
			}}>No</button>
          </div>
        </Modal>
      );
	case 4:
		  return (
			<Modal isOpen={true} onRequestClose={close} shouldCloseOnOverlayClick={true}
			  contentLabel="Landing Page Message"
			  style={{
				content: {
				  ...modalStyles.default,
				  textAlign: 'left'  // ← move inside content
				}
			  }}
			>
			  <button
				onClick={close}
				style={{
				  position: 'absolute',
				  top: '10px',
				  right: '10px',
				  fontSize: '1.5rem',
				  background: 'none',
				  border: 'none',
				  cursor: 'pointer',
				}}
				aria-label="Close"
			  >
				×
			  </button>
			<div className={TestInfoClasses.testInfo}>
    	    	<div className={TestInfoClasses.testInfoContent}>
    	    		<p className={TestInfoClasses.htmlText}>
			      		<span dangerouslySetInnerHTML={{__html:message}} />
			      	</p>
			     </div>
			</div>
			</Modal>
		  );

    default:
      return null;
  }
};

export default ModalStepper;
